import Server from '../../api/server'
import {
  API_URL,
  DELETE_INTEGRATION_ROUTE,
  GET_INTEGRATIONS_ROUTE,
  UPDATE_INTEGRATION_CONFIG_ROUTE,
  UPDATE_IVRIFY_INTEGRATION_CONFIG_ROUTE,
} from '../../strings/api-consts'
import { CustomThunkDispatch } from '../../types/UserTypes'
import { setIntegrationsList } from './integrations.slice'
import { DeleteIntegrationPayload, Integration, UpdateIntegrationPayload } from '../../types/IntegrationTypes'
import { reportErrorToDatadog } from '../../utils/error-logging'

const server = new Server()

export const fetchIntegrationsList = () => async (dispatch: CustomThunkDispatch) => {
  const url = GET_INTEGRATIONS_ROUTE

  return server
    .get(url, dispatch)
    .then((integrationsList: Integration[]) => {
      dispatch(setIntegrationsList(integrationsList))
      return integrationsList
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      dispatch(setIntegrationsList(undefined))
      return undefined
    })
}

export const updateIntegrationsConfig =
  (payload: UpdateIntegrationPayload) =>
  async (dispatch: CustomThunkDispatch): Promise<[boolean, string?]> => {
    const url = UPDATE_INTEGRATION_CONFIG_ROUTE
    return await server
      .post(url, payload, dispatch)
      .then(async (res) => {
        if (res?.status == 200) return [true, undefined] as [boolean, string?]
        const jsonRes = await res?.json()
        return [false, jsonRes.error] as [boolean, string?]
      })
      .catch((err) => {
        reportErrorToDatadog(err.message)
        return [false, undefined] as [boolean, string?]
      })
  }

export const updateIverifyConfig = (payload: UpdateIntegrationPayload) => async (dispatch: CustomThunkDispatch) => {
  const url = UPDATE_IVRIFY_INTEGRATION_CONFIG_ROUTE

  return server
    .post(url, payload, dispatch)
    .then(() => {
      return true
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      return false
    })
}

export const deleteIntegration = (payload: DeleteIntegrationPayload) => async (dispatch: CustomThunkDispatch) => {
  const url = DELETE_INTEGRATION_ROUTE

  return server
    .delete(url, dispatch, payload)
    .then(() => {
      return true
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      return false
    })
}

export const preAuthorizeIntegration =
  (internal_url: string, payload: Record<string, unknown>) => async (dispatch: CustomThunkDispatch) => {
    return server.post(internal_url, payload, dispatch).then(async (res) => {
      if (res?.status === 200) {
        const json = await res.json()
        return json.url
      } else {
        throw new Error('Failed to pre-authorize integration')
      }
    })
  }

export const executeUrlAction = (internal_url: string) => async () => {
  try {
    return await fetch(API_URL + internal_url, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      credentials: 'include',
    }).then(async (response) => {
      if (response.status === 200) {
        return await response.json()
      } else {
        return { error: 'Failed to execute URL action' }
      }
    })
  } catch (error) {
    console.error(error)
    return { error: 'Failed to execute URL action' }
  }
}
